import {postUpdateStatus} from '../api/postUpdateStatus';
import { setGetWithdrawalsAwaiting } from './setGetWithdrawalsAwaiting';

const setPostUpdateStatus = (params, setError) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateStatus(params);
            dispatch(setGetWithdrawalsAwaiting({
                page: 1,
                rowsPerPage: 10
            }))
        } catch(error) {
            if (error && error.response && error.response.data && error.response.data.message) {
                setError(error.response.data.message)
            }
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateStatus
}